mutation DeleteCameraControl($camControlId: ID!) {
  result: StreamToolsDeleteCameraControl(camControlId: $camControlId) {
    id
    deleted
  }
}
